import { render, staticRenderFns } from "./FoodGroupCard.vue?vue&type=template&id=7a9ffaac&"
import script from "./FoodGroupCard.vue?vue&type=script&lang=js&"
export * from "./FoodGroupCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports